import type { MoneyMap } from '@fruitful/types';

import type { MembershipDetails } from '../../entities/entityTypes';
import { buildMoneyMapperDraftDto } from '../utils/buildMoneyMapperDraftDto';
import { resolveMoneyMapperDefaults } from '../utils/moneyMapperDefaultValues';
import { useUpsertMoneyMap } from './useUpsertMoneyMap';

export const useCreateMoneyMapperDraft = (
    membership: MembershipDetails | null,
) => {
    const {
        mutateAsync: upsertMoneyMap,
        isPending,
        error,
    } = useUpsertMoneyMap();

    const createDraft = async (): Promise<MoneyMap | null> => {
        if (membership == null) {
            return null;
        }

        const defaults = resolveMoneyMapperDefaults(membership);
        const body = buildMoneyMapperDraftDto(membership, defaults);
        return await upsertMoneyMap({ body });
    };

    return {
        createDraft,
        isPending,
        error,
    };
};
